import { lazy } from "react";
import { Route, Routes } from "react-router-dom";

const InpatientDetailsPage = lazy(() =>
  import(
    /* webpackChunkName: "InpatientDetails" */ /* webpackPrefetch: true */ "./page"
  ).then((module) => ({ default: module.InpatientDetailsPage })),
);

const InpatientNotesPage = lazy(() =>
  import(
    /* webpackChunkName: "InpatientNotes" */ /* webpackPrefetch: true */ "./notes/page"
  ).then((module) => ({ default: module.InpatientNotesPage })),
);

const InpatientVitalsPage = lazy(() =>
  import(
    /* webpackChunkName: "InpatientVitalsPage" */ /* webpackPrefetch: true */ "./vitals/page"
  ).then((module) => ({ default: module.InpatientVitalsPage })),
);

const InpatientMedicationPage = lazy(() =>
  import(
    /* webpackChunkName: "InpatientMedicationPage" */ /* webpackPrefetch: true */ "./medication/page"
  ).then((module) => ({ default: module.InpatientMedicationPage })),
);

const InpatientDrugChartPage = lazy(() =>
  import(
    /* webpackChunkName: "InpatientDrugChartPage" */ /* webpackPrefetch: true */ "./drugchart/page"
  ).then((module) => ({ default: module.InpatientDrugChartPage })),
);

const InpatientPrescribePage = lazy(() =>
  import(
    /* webpackChunkName: "InpatientPrescribePage" */ /* webpackPrefetch: true */ "./medication/prescribe/page"
  ).then((module) => ({ default: module.InpatientPrescribePage })),
);

const InpatientAdmitPage = lazy(() =>
  import(
    /* webpackChunkName: "InpatientAdmit" */ /* webpackPrefetch: true */ "./admit/page"
  ).then((module) => ({ default: module.InpatientAdmitPage })),
);

const InpatientInvestigationsPage = lazy(() =>
  import(
    /* webpackChunkName: "InpatientInvestigations" */ /* webpackPrefetch: true */ "./investigations/page"
  ).then((module) => ({ default: module.InpatientInvestigationsPage })),
);

export const InpatientRoutes = () => {
  return (
    <Routes>
      <Route index element={<InpatientDetailsPage />} />
      <Route path="notes">
        <Route path="doctor" element={<InpatientNotesPage />} />
        <Route path="nurse" element={<InpatientNotesPage />} />
      </Route>
      <Route path="vitals" element={<InpatientVitalsPage />} />
      <Route path="medication" element={<InpatientMedicationPage />} />
      <Route path="drugchart" element={<InpatientDrugChartPage />} />
      <Route path="medication">
        <Route path="prescribe" element={<InpatientPrescribePage />} />
      </Route>
      <Route path="admit" element={<InpatientAdmitPage />} />
      <Route path="investigations" element={<InpatientInvestigationsPage />} />
    </Routes>
  );
};
